import React from "react";
import { useStorefrontConfig } from "@/context/StorefrontConfigContext";
import { resolveTrustBadges, iconComponentFor } from "@/lib/trustBadges";

/* TrustStrip — kompak, maks 4 item dari dna.trust_badges (tenant/template).
   Fallback generik netral hanya bila DNA kosong. */
export function TrustStrip() {
  const { config } = useStorefrontConfig();
  const items = resolveTrustBadges(config.dna, { max: 4, pad: false });
  if (!items.length) return null;
  return (
    <section className="gcp-trust" aria-label="Keunggulan toko" data-testid="trust-strip">
      <ul className="gcp-trust-list" data-count={items.length}>
        {items.map((b, i) => {
          const Icon = iconComponentFor(b.icon);
          return (
            <li key={`${b.icon}-${i}`} className="gcp-trust-item" data-testid={`trust-item-${i}`}>
              <span className="gcp-trust-icon" aria-hidden="true"><Icon size={17} strokeWidth={1.9} /></span>
              <span className="gcp-trust-text">{b.text}</span>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
